
/**
 * Create a simple store based on extra fields for ACF
 */
const $ = window.jQuery;
export default class SimpleStore {
  constructor(fieldSelector) {
    this.fieldSelector = fieldSelector;
    this.$hiddenElement = false;
    this.orderedItemsContainer = $('.ordered-items');
    this.products = new Map();
  }

  init() {
    $(document).on('submit', '.gform_wrapper form', event => this.fillGravityForm(event));
    $('.item.product .add-to-order').on('click', event => this.addToOrder(event));
  }

  addToOrder(e) {
    const target = e.currentTarget;
    const item = $(target).parents('.item');

    const product = {
      name: $(target).data('product'),
      price: $(target).data('price'),
      count: $('.product-amount', item).val(),
    };

    if (Number(product.count) === 0) {
      this.products.delete(product.name);
    } else {
      this.products.set(product.name, {
        price: product.price,
        count: product.count,
      });
    }

    this.showOrder();
  }

  showOrder() {
    let orderString = '<table class="table table-borderless table-sm">';

    /* eslint-disable no-restricted-syntax */
    for (const [title, product] of this.products) {
      orderString += `
        <tr class='ordered-item'>
          <td class='product-title'>${title}</td>
          <td class='product-amount'>${product.count} st</td>
          <td class='product-price'>€${product.price}</td>
        </tr>
      `;
    }
    /* eslint-enable no-restricted-syntax */

    orderString += '</table>';

    this.orderedItemsContainer.html(orderString);
  }
  
  fillGravityForm(e) {
    const hiddenElement = $(e.target).find('#input_1_3');

    if (hiddenElement.length) {
      this.$hiddenElement = hiddenElement;
    } else {
      return;
    }
  
    const products = [];
    $(this.fieldSelector).each((i, element) => {
      if (!element.value || element.value === 0) {
        return;
      }
  
      products.push({
        price: element.dataset.price,
        count: element.value,
        product: element.dataset.product,
      });
    });
  
    let value = JSON.stringify(products);
    if (!products.length) {
      value = '';
    }
  
    this.$hiddenElement.val(value);
  }
}
